export function shiftYearMonth(yearMonth, delta) {
  const match = String(yearMonth || '').match(/^(\d{4})-(\d{2})$/);
  if (!match) return '';
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1 + delta, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function compareYearMonth(left, right) {
  return String(left || '').localeCompare(String(right || ''));
}

export function formatYearMonthJa(yearMonth) {
  const match = String(yearMonth || '').match(/^(\d{4})-(\d{2})$/);
  if (!match) return yearMonth || '—';
  return `${Number(match[1])}年${Number(match[2])}月`;
}
